export default "__VITE_ASSET__CcFA1ryi__"